export const actions = {
  URL_GRUPOS_LOAD_REQUESTED: 'URL_GRUPOS_LOAD_REQUESTED',
  URL_GRUPOS_LOAD_SUCCEEDED: 'URL_GRUPOS_LOAD_SUCCEEDED',
  URL_GRUPOS_LOAD_FILED: 'URL_GRUPOS_LOAD_FILED',

  URL_GRUPO_UPDATE_REQUESTED: 'URL_GRUPO_UPDATE_REQUESTED',
  URL_GRUPO_UPDATE_SUCCEEDED: 'URL_GRUPO_UPDATE_SUCCEEDED',
  URL_GRUPO_UPDATE_FILED: 'URL_GRUPO_UPDATE_FILED',

  URL_GRUPO_INSERT_REQUESTED: 'URL_GRUPO_INSERT_REQUESTED',
  URL_GRUPO_INSERT_SUCCEEDED: 'URL_GRUPO_INSERT_SUCCEEDED',
  URL_GRUPO_INSERT_FILED: 'URL_GRUPO_INSERT_FILED',

  URL_GRUPO_DELETE_REQUESTED: 'URL_GRUPO_DELETE_REQUESTED',
  URL_GRUPO_DELETE_SUCCEEDED: 'URL_GRUPO_DELETE_SUCCEEDED',
  URL_GRUPO_DELETE_FILED: 'URL_GRUPO_DELETE_FILED',

  URL_GRUPO_BYID_LOAD_REQUESTED: 'URL_GRUPO_BYID_LOAD_REQUESTED',
  URL_GRUPO_BYID_LOAD_SUCCEEDED: 'URL_GRUPO_BYID_LOAD_SUCCEEDED',
  URL_GRUPO_BYID_LOAD_FILED: 'URL_GRUPO_BYID_LOAD_FILED',

  URL_GRUPO_BYID_LOAD_INSERT_REQUESTED: 'URL_GRUPO_BYID_LOAD_INSERT_REQUESTED',
}

export const getUrlGruposAction = (dispatch, tipoGrupo) => {
  dispatch({
    type: actions.URL_GRUPOS_LOAD_REQUESTED,
    payload: tipoGrupo,
  })
}

export const onSubmitInsertUrlGrupoFormAction = (dispatch, formPais) => {
  dispatch({
    type: actions.URL_GRUPO_INSERT_REQUESTED,
    payload: formPais,
  })
}

export const onSubmitUpdateUrlGrupoFormAction = (dispatch, formPais) => {
  dispatch({
    type: actions.URL_GRUPO_UPDATE_REQUESTED,
    payload: formPais,
  })
}

export const deleteUrlGrupoAction = (dispatch, id) => {
  dispatch({
    type: actions.URL_GRUPO_DELETE_REQUESTED,
    payload: id,
  })
}

export const getUrlGrupoCreateEditByIdAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.URL_GRUPO_BYID_LOAD_REQUESTED,
      payload: id,
    })
  } else {
    dispatch({
      type: actions.URL_GRUPO_BYID_LOAD_INSERT_REQUESTED,
    })
  }
}
